import { Component, Input, Output, EventEmitter, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';

declare const google: any;

@Component({
  selector: 'app-address-picker-modal',
  templateUrl: './address-picker-modal.component.html',
  styleUrls: ['./address-picker-modal.component.css']
})
export class AddressPickerModalComponent implements OnInit, AfterViewInit {
  @Input() existingEvents!: any;
  @Input() event: any;
  @Output() closeModal = new EventEmitter<void>();
  @Output() locationChanged = new EventEmitter<{ lat: number; lng: number; address: string; status: any; time: any }>();
  result:any;

  @ViewChild('map') map!: GoogleMap;
  google = google.maps;


  mapCenter = { lat: 0, lng: 0 };
  markerPosition = { lat: 0, lng: 0 };
  currentAddress = '';
  isLoadingAddress = false;
  submitted = false;
  isEventExist = false;
  isEdit = false;

  mapOptions: google.maps.MapOptions = {
    draggable: true,
    gestureHandling: 'greedy',
    disableDefaultUI: false,
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: false
  };

  ngOnInit() {
    if (this.event) {
      this.isEdit = this.event.status ? true : false;
      this.mapCenter = { lat: this.event.latitude, lng: this.event.longitude };
      this.markerPosition = { ...this.mapCenter };
      this.reverseGeocode(this.mapCenter.lat, this.mapCenter.lng);
    }
  }

  ngAfterViewInit() {
    if (this.map?.googleMap) {
      google.maps.event.addListener(this.map.googleMap, 'dragend', () => {
        const center = this.map.googleMap!.getCenter();
        if (!center) return;

        const lat = center.lat();
        const lng = center.lng();

        this.mapCenter = { lat, lng };
        this.markerPosition = { lat, lng };
        this.event.latitude = lat;
        this.event.longitude = lng;

        this.reverseGeocode(lat, lng);
      });
    }
  }

  private reverseGeocode(lat: number, lng: number) {
    this.isLoadingAddress = true;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
      this.isLoadingAddress = false;
      this.currentAddress =
        status === 'OK' && results && results[0] ? results[0].formatted_address : `${lat}, ${lng}`;
      this.result = {lat, lng, address: this.currentAddress };
    });
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  onAddressInputChange(address: any) {
    this.currentAddress = address;
  }

  onSelectAddress(place: google.maps.places.PlaceResult) {
    if (place.geometry?.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.mapCenter = { lat, lng };
      this.markerPosition = { lat, lng };
      this.event.latitude = lat;
      this.event.longitude = lng;
      this.currentAddress = place.formatted_address || '';

      this.map.googleMap?.panTo(this.markerPosition);

      this.result = {lat, lng, address: this.currentAddress };
    }
  }
  onConfirmLocation() {
    this.submitted = true;
    if (!this.event.status || this.isEventExist) {
      return;
    }
    console.log('Emitting location:', this.event);
    this.locationChanged.emit({...this.result, ...this.event});
    this.closeModal.emit();
  }

  onSelectStatus(event:any){
    this.isEventExist = false;
    this.event.status = event.target.value;
    if (this.event.status && this.existingEvents.length) {
      const events = this.existingEvents;
      this.isEventExist = events.some((evt: any) => evt.status === this.event.status);
    }
  }
}
